import { uuid } from '@shared/utils/uuid';

export interface TrialUsageAction {
  at: string;
  type: string;
  payload?: Record<string, unknown>;
}

let currentSessionId: string | null = null;

/** Démarre une session d’usage locale (essai uniquement). Jamais envoyée au monitoring. */
export async function startTrialUsageSession(input: {
  user_id: string;
  is_trial: boolean;
}): Promise<void> {
  if (!input.is_trial) return;
  const session = {
    id: uuid('usess'),
    user_id: input.user_id,
    is_trial: true,
    start_time: new Date().toISOString(),
    end_time: null as string | null,
    ip_address: 'local',
    user_agent: typeof navigator === 'undefined' ? null : navigator.userAgent,
    actions: [] as TrialUsageAction[],
  };
  currentSessionId = session.id;
  const ipc = window.electron?.usageStartSession;
  if (ipc) {
    try {
      await ipc(session);
    } catch {
      /* best-effort */
    }
  }
}

/** Journalise une action anonymisée (pas de nom, pas de matricule). */
export async function appendTrialUsageAction(
  type: string,
  payload?: Record<string, unknown>,
): Promise<void> {
  if (!currentSessionId) return;
  const action: TrialUsageAction = {
    at: new Date().toISOString(),
    type,
    payload: payload ? stripIdentity(payload) : undefined,
  };
  const ipc = window.electron?.usageAppendAction;
  if (ipc) {
    try {
      await ipc(currentSessionId, action);
    } catch {
      /* best-effort */
    }
  }
}

export async function endTrialUsageSession(): Promise<void> {
  if (!currentSessionId) return;
  const ipc = window.electron?.usageEndSession;
  if (ipc) {
    try {
      await ipc(currentSessionId, new Date().toISOString());
    } catch {
      /* best-effort */
    }
  }
  currentSessionId = null;
}

function stripIdentity(payload: Record<string, unknown>): Record<string, unknown> {
  const blocked = new Set([
    'nom',
    'prenom',
    'name',
    'matricule',
    'cni',
    'email',
    'telephone',
    'phone',
  ]);
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(payload)) {
    if (blocked.has(key.toLowerCase())) continue;
    out[key] = value;
  }
  return out;
}
